import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getCompanyPriceList, updateCompanyPriceList,getClerkPriceList,updateClerkPriceList} from '../actions/price_list_action';

export default function PriceListConnector(component) {
    return connect(mapStateToProps, mapDispatchToProps)(component);
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({getCompanyPriceList, updateCompanyPriceList,getClerkPriceList,updateClerkPriceList}, dispatch);
}

function mapStateToProps(state) {
    return {
        priceData: state.priceList.priceData,
        isPriceFetching: state.priceList.isPriceFetching,
        errorMessage: state.priceList.error,
        responseMessage: state.priceList.responseMessage,
        clerkPriceData:state.priceList.clerkPriceData
    };
}



// WEBPACK FOOTER //
// ./src/containers/price_list_container.js